<template>
  <div id="hero-dropdown-search" :style="{backgroundImage: bgPhoto}">
    <div class="hero-overlay"></div>
    <h2 class="text-center" id="call-to-action-overlay">
      Welcome to Auto Dealer
    </h2>
    <video v-if="images.videoLink.length > 0" autoplay="true" class="hidden-xs" id="homepage-background-video" loop="true" muted="true">
      <source
        class="ajax-video"
        :src="images.videoLink"
        type="video/mp4"
      />
    </video>
    <div class="vehicle-browse-ajax">
      <form class="vehicle-search-form" method="get">
        <input
          class="inventory-type set-on-load"
          name="new"
          type="hidden"
          value="false"
        />
        <div class="form-group">
          <select
            class="form-control vehicle-search search-inv-type"
            name="type"
          >
            <option value="default">Condition</option>
            <option data="true" value="new">New</option>
            <option data="false" value="used">Used</option></select
          ><i class="material-icons">keyboard_arrow_down</i>
        </div>
        <div class="form-group">
          <select class="form-control vehicle-search vehicle-search-make"
            name="make">
            <option value="default">{{brandName}}</option>
          </select>
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
        <div class="form-group">
          <select
            class="form-control vehicle-search vehicle-search-model"
            name="model"
          >
            <option value="default">Model</option></select
          ><i class="material-icons">keyboard_arrow_down</i>
        </div>
        <div class="form-group">
          <select
            class="form-control vehicle-search vehicle-search-year"
            name="year"
          >
            <option value="default">Year</option></select
          ><i class="material-icons">keyboard_arrow_down</i>
        </div>
        <div class="form-group" id="search-submit">
          <input
            class="btn btn-block search-form-btn vehicle-search-submit"
            value="Search"
          />
        </div>
        <br />
      </form>
      <span class="matching-vehicles-found text-center"
        ><div class="text-center">
          <span class="match-count"><b>161</b></span
          >&nbsp; matching vehicles found
        </div></span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    bgPhoto () {
      if (this.brand !== 'honda') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
#hero-dropdown-search {
  height: 75vh;
  max-height: 800px;
  margin: auto;
  padding: 5% 20px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
#hero-dropdown-search .matching-vehicles-found {
  color: white;
  font-size: 14px;
}
#hero-dropdown-search .hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
}
#call-to-action-overlay {
  color: #fff;
  font-weight: 500;
  margin-bottom: 50px;
  font-size: 3em;
  z-index: 2;
}
#homepage-background-video {
  position: absolute;
  top: -18%;
  left: 0;
  min-width: 100%;
  min-height: 118%;
  width: auto;
  height: auto;
  background-size: cover;
}
#hero-dropdown-search .vehicle-browse-ajax {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  z-index: 2;
}
#hero-dropdown-search .form-group {
  flex-grow: 1;
  position: relative;
}
#hero-dropdown-search .search-form-btn.vehicle-search-submit {
  background-color: var(--primary-color);
  color: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 0;
  font-size: 16px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
  }
#hero-dropdown-search .search-form-btn.vehicle-search-submit:hover {
  background-color: var(--primary-dark);
  border: 1px solid var(--primary-dark);
}
#hp-dropdown-search .form-group input, #hero-dropdown-search .search-form-btn.vehicle-search-submit {
  line-height: 32px;
}
#hero-dropdown-search .form-group i {
  position: absolute;
  line-height: 48px;
  right: 12px;
  top: 0;
}
#hero-dropdown-search .form-control {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 32px;
  position: relative;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 1;
  border-radius: 0;
  background: #fff;
}
#hero-dropdown-search .matching-vehicles-found {
  margin-top: 25px;
  display: block;
}

@media (max-width: 1199px) {
  #homepage-background-video {
    top: 0;
  }
}

@media (min-width: 768px) {
  #hero-dropdown-search .vehicle-search-form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  #hero-dropdown-search .form-group {
    flex-basis: 20%;
  }
  #hero-dropdown-search .form-group:not(:last-child) {
    margin-right: 12px;
  }
}

@media (max-width: 768px) {
  #call-to-action-overlay {
    font-size: 30px;
  }
}
</style>